import {SaveOutlined} from '@mui/icons-material';

import {EMMAI_FORMS} from '../../../../../../../const';
import useEmmai from '../../../../../../../hooks/providers/useEmmai';
import ToolbarIconButton from '../ToolbarIconButton/ToolbarIconButton';

const SavePractitionerButton = () => {
  const {practitionerFormMethods, submitPractitioner, isPractitionerUpdating, currentForm} = useEmmai();
  const {formState} = practitionerFormMethods;
  const {isValid, isSubmitting, isDirty} = formState;

  if (!(currentForm === EMMAI_FORMS.ADD_OR_UPDATE_PRACTITIONER && isPractitionerUpdating)) return null;

  return (
    <ToolbarIconButton disabled={!isValid || isSubmitting || !isDirty} onClick={submitPractitioner} edge="end" aria-label="modifier praticien">
      <SaveOutlined color="primary" sx={{fontSize: 12}} />
    </ToolbarIconButton>
  );
};

export default SavePractitionerButton;
